/* eslint-disable no-shadow */
/* eslint-disable no-console */
import type { BlockComponentProps } from 'client-react-block-renderer';
import React from 'react';
import GASettingsForm from './GASettingsForm.client';
import getAppState from 'app-state';
import type { pwsData } from '../types/pwsData';
import type { currentUser } from '../types/currentUser';
import { getCurrentUserId } from '@rcm/current-user';
import t from '@rcm/i18n-client';

interface Props extends BlockComponentProps<BlockData, BlockConfig> {}

interface BlockConfig {}

interface BlockData {}

const GASettingsBlock = (props: Props) => {
  const pwsData: pwsData = getAppState('pws', null) ?? null;
  const currentUser: currentUser = getAppState('currentUser', null) ?? null;
  const isEmployee = currentUser?.profile?.status === 'E';
  const userId: string = currentUser?.userId;

  if ((pwsData && !getCurrentUserId()) || (!pwsData?.isOwner && !isEmployee)) {
    window.location.href = '/login?errorCode=unauthorized&redirect=' + encodeURIComponent(window.location.pathname);
    return null;
  }
  if (!getCurrentUserId()) return <div>{t('You must be logged in before you can use this page.')}</div>;

  return <GASettingsForm data={pwsData} userId={userId} isEmployee={isEmployee} />;
};
export default GASettingsBlock;
